import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import breakpoints from "@constants/breakpoints"
import {
  h3Styles,
  h4Styles,
  smallcapsBold13Styles,
  smallcapsBold14Styles,
} from "@constants/typography"

const Container = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
`

const Title = styled.h1`
  ${h4Styles}

  @media ${breakpoints.tablet} {
    ${h3Styles}
    margin-bottom: 28px;
  }

  @media ${breakpoints.laptop} {
    ${h4Styles}
    margin-bottom: 12px;
    font-size: 30px;
    line-height: 36px;
  }
`

const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`

const RetailPrice = styled.div`
  ${smallcapsBold13Styles}
  margin-right: 12px;
  padding-top: 3px;
  color: ${colors.mediumGray};
  text-decoration: line-through;

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
    color: ${colors.mediumGray};
    text-decoration: line-through;
  }
`

const Price = styled.div`
  ${smallcapsBold13Styles}
  margin-right: 16px;
  padding-top: 3px;

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
  }
`

interface ProductTitleProps {
  className?: string
  productName: string
  retailPrice?: string
  price: string
  hidePrice?: boolean
}

const ProductTitle = (props: ProductTitleProps) => {
  const price = parseFloat(props.price)

  return (
    <Container className={props.className}>
      <Title>{props.productName}</Title>
      {!props.hidePrice && (
        <PriceRow>
          {props.retailPrice && props.retailPrice !== props.price && (
            <RetailPrice>
              {parseFloat(props.retailPrice).toFixed(2)}
            </RetailPrice>
          )}
          <Price>{`$${price.toFixed(2)}`}</Price>
        </PriceRow>
      )}
    </Container>
  )
}

export default ProductTitle
